<template>
  <div class="base_color">
    <div id="container">

      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause">
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          上海浦东发展银行
        </p>
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          电子银行个人客户服务协议
        </p>
        <p class="distance_50">
          为明确双方的权利和义务，个人客户（以下简称“客户”）和上海浦东发展银行（以下简称“银行”）本着平等互利的原则，就电子银行服务相关事宜达成本协议，以资共同遵守。
        </p>
        <p class="distance_50">
          第一条 业务定义
        </p>
        <p class="distance_50">
          下列用语在本协议中的含义为：
        </p>
        <p class="distance_50">
          “电子银行”指银行通过面向社会公众开放的通讯通道或公共通讯网络，以及为特定自助服务设施或客户建立的专用网络等方式，为客户提供的离柜金融服务。根据服务渠道的不同，可分为个人网上银行服务、个人手机银行服务、及时语服务、电视银行服务、自助银行服务（包括自动柜员机、自动存款机、自动存取款机、多媒体自助服务机等自助设备，下同）等。
        </p>
        <p class="distance_50">
          “身份认证要素”指银行用于识别客户身份的信息要素，如客户号、登录昵称、账号、各类密码、数字证书、签约设置的电话或手机号码等。
        </p>
        <p class="distance_50">
          “密码”指客户确认身份的字符信息，分为客户查询密码、凭证（卡/折/单/电子账户等）交易密码和动态密码。动态密码以手机短信方式发送到客户预留的手机上。
        </p>
        <p class="distance_50">
          “数字证书”指用于存放客户身份标识，并对客户发送的电子银行交易信息进行数字签名的电子文件。
        </p>
        <p class="distance_50">
          “业务指令”指客户通过电子银行凭借相关的身份认证要素发起的查询、转账等电子指令的统称。
        </p>
        <p class="distance_50">
          第二条 服务内容
        </p>
        <p class="distance_50">
          （一）个人网上银行服务内容
        </p>
        <p class="distance_50">
          客户通过银行柜面或其它途径申请签约并办理相关手续后，即成为个人网上银行客户。个人网上银行客户可享受的服务包括：账户管理、投资理财、贷款融资、汇款支付、公共事业缴费等服务，以及申请开通或变更网上银行所提供的其他功能。
        </p>
        <p class="distance_50">
          （二）个人手机银行服务内容
        </p>
        <p class="distance">
          客户通过银行柜面或其它途径申请签约并办理相关手续后，即成为手机银行的签约客户。签约客户可享受的服务包括：账户管理、投资理财、汇款支付、公共事业缴费等服务，以及申请开通或变更手机银行所提供的其他功能。
        </p>
        <p class="distance_50">
          （三）及时语服务内容
        </p>
        <p class="distance_50">
          客户通过银行柜面或其它途径申请签约并办理相关手续后，即成为及时语服务的签约客户。签约客户可享受的服务包括：短信通知、短信查询、邮件通知等服务，以及申请开通或变更及时语服务所提供的其他功能。
        </p>
        <p class="distance_50">
          （四）电视银行服务内容
        </p>
        <p class="distance_50">
          客户通过银行柜面或其它途径申请签约并办理相关手续后，即成为电视银行的签约客户。签约客户可享受的服务包括：账户管理、投资理财、公共事业缴费等服务，以及申请开通或变更电视银行所提供的其他功能。
        </p>
        <p class="distance_50">
          （五）自助银行服务内容
        </p>
        <p class="distance_50">
          客户通过银行柜面或其它途径申请签约自助设备转账等协议并办理相关手续后，即可享受自助银行汇款支付等服务。客户可享受的服务包括：现金存取、发卡签约、账户管理、投资理财、公共事业缴费等。
        </p>
        <p class="distance_50">
          第三条 客户权利和义务
        </p>
        <p class="distance_50">
          （一）权利
        </p>
        <p class="distance_50">
          1.客户自愿申请签约银行电子银行，经银行审核同意后，将有权根据签约项目的类别享受相应的服务。
        </p>
        <p class="distance_50">
          2.客户有权通过银行网站或营业网点查询了解电子银行业务收费标准。
        </p>
        <p class="distance_50">
          3.客户在注册期内有权申请办理手机号码修改、数字证书更新等电子银行变更手续。
        </p>
        <p class="distance_50">
          4.客户在注册期内有权办理电子银行注销手续。
        </p>
        <p class="distance_50">
          5.
          如选择不接受银行对电子银行业务服务范围、章程及服务协议内容的变更，客户有权在银行公告期内至银行网点办理电子银行注销手续。
        </p>
        <p class="distance_50">
          6.客户对银行电子银行服务如有疑问、建议或意见时，可拨打客服电话“95528”或到银行营业网点进行咨询和投诉。
        </p>
        <p class="distance_50">
          （二）义务
        </p>
        <p class="distance_50">
          1.客户办理电子银行业务，应遵守本协议、《上海浦东发展银行电子银行章程》和银行相关业务规定的各项内容。客户到银行营业网点办理电子银行签约、注销、变更等手续，应由本人亲自办理。办理时应根据银行要求提供相关资料，按银行要求填写申请表，并签名确认。客户向银行提供的业务申请表是本协议不可分割的组成部分。客户应保证所填写的申请表与所提供的资料真实、准确、完整，因客户提供信息不真实、不准确或不完整所造成的损失由客户承担。
        </p>
        <p class="distance_50">
          2.客户办理个人网上银行业务应直接登录银行网站（网址：www.spdb.com.cn）；客户通过邮件或其他网站提供的链接地址等其他方式登录所产生的不利后果由客户自行承担。客户办理手机银行（WAP）业务应通过手机直接登录银行手机银行（WAP）网站（网址：http://wap.spdb.com.cn）；客户使用通过移动客户端登录的电子银行，移动客户端软件应从银行网站或设备指定软件下载网站下载。
        </p>
        <p class="distance_50">
          3.客户的客户号、卡/折号、密码、数字证书、接收动态密码的手机是客户进行电子银行交易的重要要素，客户承诺由本人妥善保管，并保证不将该等资料或物品提供或泄露给任何第三方，对因自身提供、泄露、被窃、遗失等原因造成该等资料或物品被他人使用的，该行为视为客户自身完成的行为，客户对该使用行为的后果承担责任。银行执行客户通过电子银行发出的业务指令后，客户不得要求变更或撤销业务指令。
        </p>
        <p class="distance_50">
          4.客户应按照机密的原则设置和保管密码，避免使用生日、电话号码等与本人相关的信息作为密码；不得将本人自设密码、动态密码提供给除法律规定外的任何人；应采取其他合理措施，防止本人密码被窃取。由于密码泄露造成的后果由客户承担。
        </p>
        <p class="distance_50">
          5.客户办理电子银行签约业务，客户应确保向银行提供本人实名登记的手机号。银行向该手机号发送用于安全认证的动态密码短信，客户须确认短信发送编号、交易类型和交易金额等信息与正在进行的交易事项一致，并正确输入收到的动态密码。非银行原因（例如短信网络原因造成迟延、信息丢失，客户提供手机号有误、手机关机、欠费停机、手机号码变更，客户未认真核对信息、未正确操作等原因）导致交易无法完成以及导致的一切损失，银行不承担责任。
        </p>
        <p class="distance_50">
          6.客户发生卡/折丢失、密码泄露、数字证书丢失、接收动态密码的手机丢失、停机或手机号码变更等情况，应及时到银行营业网点办理挂失或手机号码变更等手续，否则可能产生无法正常使用电子银行功能、账户资金安全性降低等各类风险。客户承担到银行营业网点办妥相关手续并生效之前所产生的一切后果。
        </p>
        <p class="distance_50">
          7.客户在使用电子银行服务过程中，所提供的注册信息如需更改，应及时按照银行要求办理有关手续，在上述手续办妥并生效之前所产生的一切后果由客户承担。
        </p>
        <p class="distance_50">
          8.客户应保证办理电子银行业务的账户的支付能力，并严格遵守支付结算业务的相关法律法规及金融监管机构的要求。客户不得以与第三方发生纠纷为由拒绝支付应付银行的各类款项。
        </p>
        <p class="distance_50">
          9.客户不得有意诋毁、损害银行声誉或恶意攻击银行电子银行系统。
        </p>
        <p class="distance_50">
          10.客户办理电子银行业务时，如其使用的服务功能涉及到银行其他业务规定或规则的，须同时遵守相关规定或规则。
        </p>
        <p class="distance_50">
          11.客户长期不使用电子银行，应主动向银行申请办理电子银行的注销手续，否则由其自身承担可能产生的各类风险。
        </p>
        <p class="distance_50">
          12.网银U-Key等账户存取工具和安全认证工具只限客户本人使用，不得出租、出借、出售或转让等，否则客户承担由此产生的一切后果。
        </p>
        <p class="distance_50">
          13.电子银行只限客户本人使用，不得转让、出租、转借、出售，否则由此产生的一切后果由客户承担。客户不得利用电子银行从事任何违反国家法律法规及规章的活动。对可能涉及非法、违规行为的任何交易，银行保留拒绝处理或支付的权利，并有权采取限制或终止服务措施。客户不得使用电子银行参与洗钱、恐怖融资或扩散（大规模杀伤性武器）融资等活动，对可能涉嫌参与上述活动的客户，银行有权对其电子银行采取中止服务、主动锁定和/或销户等措施，并有权终止本协议且不承担任何责任。
        </p>
        <p class="distance_50">
          上述洗钱、恐怖融资或扩散（大规模杀伤性武器）融资等活动，是指联合国安理会、反洗钱金融行动特别工作组、中国、美国、欧盟等国际组织或国家认定的洗钱、恐怖融资或扩散（大规模杀伤性武器）融资行为。
        </p>
        <p class="distance_50">
          第四条 银行的权利和义务
        </p>
        <p class="distance_50">
          （一）权利
        </p>
        <p class="distance_50">
          1.银行有权根据客户资信情况，决定是否受理客户的注册申请。
        </p>
        <p class="distance_50">
          2.银行有权制定电子银行业务收费标准，并在网站或营业网点公布后生效。
        </p>
        <p class="distance_50">
          3.银行有权对电子银行系统进行升级、改造。
        </p>
        <p class="distance_50">
          4.为保护客户个人信息，银行有权主动锁定存在信息泄露风险的客户的电子银行的全部或部分功能。
        </p>
        <p class="distance_50">
          5.客户存在恶意操作、恶意攻击，诋毁、损害银行声誉等情况的，银行有权单方终止对客户提供电子银行服务，并保留追究客户责任的权利。客户利用银行电子银行从事违反国家法律法规或监管机构要求的活动时，银行将有权停止为其办理电子银行业务。
        </p>

        <p class="distance_50">
          6.客户同意银行根据客户的电子银行业务指令办理业务，对所有使用客户号、登录昵称、身份证号码、卡/折号、签约设置的电话或手机号、密码或数字证书等进行的操作均视为客户本人所为，该操作所产生的电子信息记录均为银行处理电子银行业务的有效凭据。
        </p>
        <p class="distance_50">
          7.银行因以下情况没有正确执行客户提交的电子银行业务指令，不承担任何责任：
        </p>
        <p class="distance_50">
          （1）银行接收到的指令信息不明、存在乱码、不完整等。
        </p>
        <p class="distance_50">
          （2）客户账户存款余额或信用额度不足。
        </p>
        <p class="distance_50">
          （3）客户账户内资金被依法冻结或扣划。
        </p>
        <p class="distance_50">
          （4）客户未能按照银行的有关业务规定正确操作。
        </p>
        <p class="distance_50">
          （5）因不可抗力或系统故障、供电故障、通讯故障或网络故障等其他非银行所能控制的事件引起的电子银行业务功能丧失、延迟和数据损坏等造成客户经济损失。
        </p>
        <p class="distance_50">
          8.银行有权通过网站或营业网点公告形式变更电子银行业务的服务范围、章程及服务协议，并设置公告期。
        </p>

        <p class="distance_50">
          9.银行有权根据相关法律法规、监管机构要求、本业务章程及本协议约定等中止或终止为客户提供全部或部分电子银行服务。协议终止或在服务有效期内中止时，银行有权不退回客户已支付的所有费用。
        </p>
        <p class="distance_50">
          （二）义务
        </p>
        <p class="distance_50">
          1.在银行系统正常运行情况下，银行负责及时准确地处理客户发送的电子银行业务指令，并及时向客户提供查询交易记录、资金余额、账户状态等服务。
        </p>
        <p class="distance_50">
          2.银行对于电子银行所使用的相关软件的合法性承担责任。
        </p>
        <p class="distance_50">
          3.银行负责及时为客户办理电子银行签约手续，并按客户注册功能的不同为客户提供相应的电子银行服务。
        </p>

        <p class="distance_50">
          4.银行负责向客户提供电子银行业务咨询服务。
        </p>
        <p class="distance_50">
          5.银行在法律法规许可和客户授权的范围内使用客户的资料和交易记录。银行对客户提供的申请资料和其他信息负有保密的义务，但法律法规或监管机构另有规定的除外。
        </p>
        <p class="distance_50" style="color: red">
          银行收集、使用、储存和共享、转让、公开披露等客户资料及交易记录等信息时须与客户共同遵守《上海浦东发展银行个人客户隐私政策》（详见附件1）
        </p>
        <p class="distance_50">
          6.如客户提供充分证据证明完全由于银行的原因或重大过失造成客户电子银行业务操作的失败或错误，银行应负责赔偿签约客户的经济损失，但任何情况下，银行的赔偿责任应仅限于客户的直接经济损失（即银行手续费），银行的赔偿责任不应包括客户的任何间接损失（例如其预期收益、商业利润等）。
        </p>
        <p class="distance_50">
          第五条 法律适用条款
        </p>

        <p class="distance_50">
          本协议适用中华人民共和国法律（为本协议之目的，在此不包括香港、澳门特别行政区和台湾地区法律）并按其解释。法律无明文规定的，可适用通行的金融惯例。
        </p>
        <p class="distance_50">
          本协议是银行的其他既有协议和约定的补充而非替代文件，如本协议与其他既有协议和约定有冲突，涉及电子银行业务内容的，应以本协议为准。
        </p>
        <p class="distance_50">
          第六条 差错和争议的解决
        </p>
        <p class="distance_50">
          客户发现自身未按规定操作，或由于自身其他原因造成电子银行业务指令未执行、未适当执行、延迟执行的，应及时通过拨打服务热线“
          95528”或到营业网点通知银行。银行应积极调查并告知客户调查结果。
        </p>
        <p class="distance_50">
          双方在履行本协议的过程中，如发生争议，应协商解决。协商不成的，任何一方均可向银行所在地有管辖权的人民法院提起诉讼。双方另有约定的除外。
        </p>
        <p class="distance_50">
          第七条 协议的中止和终止
        </p>
        <p class="distance_50">
          客户电子银行注销手续办理完毕，本协议即为终止。
        </p>
        <p class="distance_50">
          在客户违反本协议规定或其它银行业务规定的情况下，银行有权中止或终止本协议。协议终止并不意味着客户在终止前所发生的未完成交易指令的撤销，也不能消除客户因终止前的交易所应承担的任何法律后果。客户在终止前已发送的交易指令仍有效并应承担其后果，但浦发银行电子银行各项业务规定中另有约定的除外。银行不退还已收取服务费及其他相关费用。
        </p>
        <p
          class="distance_50"
        >
          第八条 协议的效力和生效
        </p>
        <p class="distance_50">
          本协议的任何条款如因任何原因而被确认无效，都不影响本协议其他条款的效力。本协议自客户在线确认同意时生效。
        </p>
        <p class="distance_50">
          第九条 其它
        </p>
        <p class="distance_50">
          上述条款中未尽事项以及相关词语定义适用《上海浦东发展银行电子银行章程》中的规定。
        </p>
        <p class="distance_50">
          本协议附件是本协议不可分割的组成部分，与本协议正文具有同等的法律效力。
        </p>
        <p class="distance_50">
          双方确认，在签署本协议前，已就全部条款进行了详细地说明和讨论，双方对合同的全部条款均无疑义，并对协议涉及的权利义务、责任限制及免责条款的法律含义有了准确无误的理解。客户使用银行电子银行服务即视为客户已了解并完全接受《上海浦东发展银行电子银行章程》。
        </p>
        <br />
        <p class="distance_50">附件1</p>
        <br />
        <p
          class="distance_50"
          style="font-weight: bold; font-size: 16px;text-align:center"
        >
          上海浦东发展银行个人客户隐私政策
        </p>
        <p class="distance_50" style="font-size: 12px;text-align:center">
          本版发布日期：2020年6月22日
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          上海浦东发展银行一直重视并采取措施保护用户（以下简称“您”）的个人信息。我行将根据本《上海浦东发展银行个人客户隐私政策》（以下简称“本政策”）以及其他相关法律文本中的有关约定在中华人民共和国境内（不包括香港、澳门特别行政区及台湾地区）收集、使用、储存及共享、转让、公开披露您的个人信息。此外，我行将通过本政策，说明您如何访问、更正或更新、删除、管理您的个人信息以及行使您的相关权利。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          我行强烈建议您在使用我行的服务前，仔细阅读并完全理解本政策中的全部内容，并自主进行适当的选择。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          本政策适用于浦发银行提供的所有个人客户银行服务，如我行在具体产品或服务中与您就隐私保护政策另有具体约定的，相关约定与本政策将共同构成我行与您之间的隐私政策约定，二者如有不一致之处的，以具体产品或服务中的约定为准。
        </p>
        <p class="distance_50">
          本政策将向您介绍以下内容：
        </p>
        <p class="distance_50">
          1．我行如何收集和使用您的个人信息
        </p>
        <p class="distance_50">
          2．我行如何使用 Cookie和同类技术
        </p>
        <p class="distance_50">
          3．我行如何共享、转让和公开披露您的个人信息
        </p>
        <p class="distance_50">
          4．我行如何存储和保护您的个人信息
        </p>
        <p class="distance_50">
          5．您如何管理您的个人信息
        </p>
        <p class="distance_50">
          6．我行如何处理未成年人的信息
        </p>
        <p class="distance_50">
          7．本政策如何更新
        </p>
        <p class="distance_50">
          8．如何联系我行
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          一、我行如何收集和使用您的个人信息
        </p>
        <p class="distance_50">
          个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
        </p>
        <p class="distance_50">
          个人信息包括姓名、出生日期、身份证件号码、个人生物识别信息、通信通讯联系方式、住址、账户信息、交易信息、财产信息、信用信息、消费偏好、行踪轨迹、联网核查信息等。
        </p>

        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）我行收集个人信息的原则
        </p>
        <p class="distance_50">
          我行收集您的个人信息遵循合法、正当、必要的原则。我行按照法律法规要求以及业务需要收集您的个人信息，不会收集与业务无关的信息或采取不正当方式收集信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）我行收集您的个人信息的目的
        </p>
        <p class="distance_50">
          我行收集您的个人信息，目的在于依法合规地为您提供优质的产品（或服务），该等信息对于充分履行您和我行之间的合约很有必要，并使得我行能够遵守相关法律，具体包括：
        </p>
        <p class="distance_50">
          1.为保护您的账户安全，对您的身份进行识别、验证等；
        </p>
        <p class="distance_50">
          2.为评估您的履约能力及状况，用于业务准入和风险防控；
        </p>

        <p class="distance_50">
          3.为您提供产品（或服务）所必须（包括但不限于为购买理财类产品进行的风险承受能力评估问卷、为评估您的风险偏好，合理提供产品推介和投资建议等）；
        </p>
        <p class="distance_50">
          4.为保护您的资金安全；
        </p>
        <p class="distance_50">
          5.为改善产品（或服务）、提升您的体验；
        </p>
        <p class="distance_50">
          6.为履行法定义务（如反洗钱义务等）；
        </p>
        <p class="distance_50">
          7.经您许可的其他用途。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）我行收集您的个人信息的方式
        </p>
        <p class="distance_50">
          为向您提供服务并确保您的电子银行服务（网上银行服务、手机银行服务、短信服务、微信银行服务、电话银行服务、直销银行服务等）安全，在您使用电子银行服务过程中，我行会收集您在使用服务过程中主动输入或因使用服务而产生的信息：
        </p>
        <p class="distance_50">
          1.当您开通电子银行服务时，依据法律法规及监管要求，我行会收集您的
          <span style="color:#000;font-weight:bold"
            >个人基本资料、身份信息、财产信息、通信信息、生物识别信息、手机号码信息，</span
          >
          以帮助您完成电子银行注册，如果您拒绝提供这些信息，您可能无法开通电子银行或无法正常使用我行的服务。
        </p>
        <p class="distance_50">
          2.当您使用浦发银行电子银行服务时，例如在下列情形中，您需要向我行提供或授权我行收集相应服务所需的用户信息。如您拒绝提供，您将无法使用相应功能或服务。
        </p>
        <p class="distance_50">
          （1） 当您注册浦发银行手机银行时，我行会收集您的
          <span style="color:#000;font-weight:bold"
            >手机号码、头像、昵称、身份证件信息、银行卡信息，</span
          >
          并验证您的客户查询密码、以及银行卡交易密码，在需要短信验证码的环节，需要读取验证码短信内容，以协助您进行验证码填写。如您拒绝通讯信息授权，我行手机银行将不读取短信内容，我行不保存短信内容。
        </p>
        <p class="distance_50">
          （2）如您在手机银行中选择通过指纹/FACE
          ID、声纹、刷脸功能进行登录、转账、支付、身份认证，需向我行提供您的<span
            style="color:#000;font-weight:bold"
            >指纹/FACE ID、声音、人脸图像信息。</span
          >我行不会采集您的指纹/FACE ID，您的指纹/FACE
          ID仅保存在您授权采集指纹的设备上。经您授权后，我行将采集您的声纹信息、人脸信息，将加密存储于我行信息系统后台数据库中。如您不提供上述信息，我行将无法向您提供需完成指纹/FACE
          ID、声纹、人脸认证后方可使用的产品或服务。您可以通过“首页-全部-安全”或在首页搜索关键词“认证”开启或关闭此功能。
        </p>
        <p class="distance_50">
          （3）当您使用微信、支付宝授权登录功能时，我行需要您提供<span
            style="color:#000;font-weight:bold"
            >微信、支付宝账号的昵称与头像信息。</span
          >您可以通过“首页-全部-第三方账号管理”取消授权及相应账号信息绑定。
        </p>
        <p class="distance_50">
          （4）当您使用我行及时语服务时，我行会收集您的<span style="color:#000;font-weight:bold"
            >账户信息和交易信息，手机号/邮箱地址/微信昵称/支付宝昵称，</span
          >以便及时向您发送账户资金变动及相关交易通知；我行也可能向我行的合作伙伴收集其合法留存并经您授权可以共享使用的信息，以便为您提供相应消息通知等服务。
        </p>
        <p class="distance_50">
          （5） 当您使用网点服务等基于地理位置的功能时，我行会收集您的<span
            style="color:#000;font-weight:bold"
            >位置信息，</span
          >目的是为了向您提供所在位置的相应服务。如您拒绝提供该信息，您将无法使用上述功能，但这不影响您正常使用手机银行的其他功能。
        </p>
        <p class="distance_50">
          （6）当您使用手机号转账等涉及通讯录的功能时，<span style="color:#000;font-weight:bold"
            >我行仅获取您从通讯录中点选的联系人信息，</span
          >并进行加密传输以防止恶意截取。上述信息属于个人敏感信息。如您不需使用上述功能，可以不提供该信息，不影响您正常使用其他功能。
        </p>
        <p class="distance_50">
          （7）当您使用转账汇款、小浦支付、扫码支付等收付款功能时，您需要提供<span
            style="color:#000;font-weight:bold"
            >收款方的姓名、银行卡号/账户等信息，并可能需要提供您的姓名、手机号、证件类型、证件号码等信息，</span
          >以便验证身份使用上述支付功能。此外，我行还会收集您的相关收付款交易记录以便您查询。具体事项按您开通我行手机银行时同意签署的《上海浦东发展银行电子银行个人客户服务协议》执行。上述信息属于敏感信息，如您拒绝提供，将无法使用上述功能，但不影响您使用手机银行其他功能。
        </p>
        <p class="distance_50">
          （8）当您使用搜索服务时，我行会收集您的<span style="color:#000;font-weight:bold"
            >搜索关键词信息。</span
          >当搜索关键词信息无法单独识别您的个人身份时，该信息不属于您的用户信息，我行可以对其加以其他目的使用；当搜索关键词信息与您的其他信息结合可以识别您的个人身份时，我行将在结合期间将您的搜索关键词信息作为您的用户信息，对其加以保护处理。
        </p>
        <p class="distance_50">
          （9）当您使用我行提供的实名认证服务时，我行可能需要您提供您的<span
            style="color:#000;font-weight:bold"
            >姓名、证件类型、证件号码、银行卡号、设备信息、指纹/FACE
            ID信息、刷脸认证</span
          >等信息，并可能通过验证手机号/查询密码、银行卡号/卡密码、短信验证码等方式对有关信息进行有效性核验。若您不提供上述信息，我行将无法向您提供须完成实名认证后方可使用的产品或服务。
        </p>
        <p class="distance_50">
          （10）当您使用内嵌的购物及生活服务等功能时，您需要在订单页面填写<span
            style="color:#000;font-weight:bold"
            >收货人姓名、收货地址及手机号码等信息；</span
          >您在预定电影票、出行、酒店等服务时，还可能需要根据国家法律法规及监管要求或服务提供方（包括票务销售方、酒店、旅行社及其授权的代理方、基础电信运营商、移动转售运营商等）的要求提供<span
            style="color:#000;font-weight:bold"
            >您的实名信息，</span
          >这些实名信息可能包括您的身份信息（比如身份证、军官证、护照、驾驶证等载明您身份的证件）、您本人的照片或视频、联系电话等。这些订单中将可能包含<span
            style="color:#000;font-weight:bold"
            >您的行程、酒店地址</span
          >等信息。上述所有信息构成您的订单信息，我行将使用您的<span
            style="color:#000;font-weight:bold"
            >订单信息</span
          >来进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务；我行还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。
        </p>
        <p class="distance_50">
          下单后，您可以选择使用浦发卡支付或他行卡支付。当您下单并选择货到付款或在线完成支付后，商户和第三方配送公司将为您完成订单的交付。您在此同意，商户和第三方配送公司、售后服务等可以使用您的订单信息以为您提供商品或服务。
        </p>
        <p class="distance_50">
          我行的电话客服和售后功能会使用您的<span style="color:#000;font-weight:bold"
            >账号信息和订单信息。</span
          >为保证您的账号安全，我行的呼叫中心客服和在线客服会使用您的账号信息与您核验身份。当您需要我行提供与您订单信息相关的客服与售后服务时，我行将会查询您的<span
            style="color:#000;font-weight:bold"
            >订单信息。</span
          >您有可能会在与我行的客服人员沟通时，提供除上述信息外的其他信息，例如：当您要求我行变更配送地址、联系人或联系电话时。
        </p>
        <p class="distance_50">
          3.当您使用电子银行服务时，为了维护服务的正常运行，优化我行的服务体验及保障您的账号安全，我行会收集以下基础信息，包括您的<span
            style="color:#000;font-weight:bold"
            >设备型号、操作系统、唯一设备标识符、手机银行软件版本号、登录IP地址、接入网络的方式、类型和状态、网络质量数据、设备加速器（如重力感应设备）、操作日志、服务日志信息（如您在手机银行搜索、查看的信息、服务故障信息等），</span
          >这些信息是为您提供服务必须收集的基础信息，以保障您正常使用我行的服务。
        </p>
        <p class="distance_50">
          在特定使用场景下，我行会使用具有相应业务资质及服务能力的第三方服务商提供的软件开发工具包（简称“SDK”）来为您提供服务，<span
            style="color:#000;font-weight:bold"
            >此时需要通过SDK来收集您的必要信息，</span
          >对应使用场景详见附件。
        </p>
        <p class="distance_50">
          4.为向您提供更加准确、个性和便捷的服务，提升服务体验、改进服务质量，或为防范风险，我行会收集您<span
            style="color:#000;font-weight:bold"
            >反馈意见建议或举报时提供的信息，</span
          >收集您参与问卷调查时向我行反馈的信息，收集您使用电子银行功能或服务的类别、方式和操作信息，及您在我行的用户信息，我行会对这些信息进行统计、分析，并会根据上述信息向您提供相应服务或产品。
        </p>
        <p class="distance_50">
          5.当您在电子银行中使用第三方提供的服务时，第三方可能会获取<span
            style="color:#000;font-weight:bold"
            >您的昵称、头像、位置、姓名、证件类型、证件号码、手机号码信息；</span
          >在经过您的明示同意后，第三方可获取您的以上信息；对于您在使用第三方提供的服务时主动提供给第三方的相关信息，我行将视为您允许该第三方获取上述此类信息；对于您在使用该第三方服务时产生的信息，应由您与该第三方依法约定上述信息的收集和使用事项。如您拒绝第三方在提供服务时收集、使用或者传递上述信息，将可能会导致您无法在电子银行中使用第三方的相应服务，但这不影响您使用电子银行的其他功能。
        </p>
        <p class="distance_50">
          6.以下情形中，您可选择是否授权我行收集、使用您的个人信息：
        </p>
        <p class="distance_50">
          （1）设备状态，用于确定设备识别码，以保证账户登录的安全性。拒绝授权后，将无法正常使用浦发银行手机银行App。
        </p>
        <p class="distance_50">
          （2）存储权限，用于缓存您在使用APP过程中产生的文本、图像、视频等内容。拒绝授权后，将无法正常使用浦发银行手机银行App。
        </p>
        <p class="distance_50">
          （3）摄像头，用于如识别二维码、人脸识别、设置头像、拍摄证件信息用途，在人脸识别登录/转账/支付/认证、扫一扫、AR扫、头像设置、证件信息上传开通场景中使用。拒绝授权后，上述功能将无法使用。我行将获取的人脸等数据，加密后存储于系统后台数据库中。
        </p>
        <p class="distance_50">
          （4）相册，访问相册主要用于上传开户证件、设置您的头像、备注交易信息，保存电子回单等。我行获得的图片信息，加密后存储于数据库中。拒绝授权后，上述功能将无法使用。
        </p>
        <p class="distance_50">
          （5）麦克风，用于U-Key、声纹识别、录音、语音银行等用途，且仅在客户使用U-Key认证、声纹登录/转账/支付、语音银行场景中运用该权限。拒绝授权后，上述功能将无法使用。我行采集的声纹数据及录音数据，加密后存储于系统后台数据库中。
        </p>
        <p class="distance_50">
          （6）手机通讯录，在转账、支付，或参与个人活动过程中，用于协助您通过通讯录快速选取电话号码，无需您手动输入。拒绝授权后，向手机号转账、短信通知功能仍可以使用，但需要手工输入手机号码。手机银行仅读取并记录指定电话号码，不读取客户全量通讯录，我行后台系统不存储通讯录。
        </p>
        <p class="distance_50">
          （7）手机短信，在需要短信验证码的环节需要读取验证码短信内容协助您进行验证码填写。如您拒绝通讯信息（短信）授权，我行手机银行将不读取短信内容，系统后台不保存短信内容。
        </p>
        <p class="distance_50">
          （8）地理位置，获取您所在地理位置，主要用于电子银行交易风控、网点预约、ATM位置查询等服务。系统后台保存您交易时的位置信息。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （9）电话权限，用于使用手机银行时，拨打电话联系客服、线下网点等用途，且仅在客户使用场景中运用该权限。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （10）SIRI，用于通过SIRI办理登录、查询等用途，且仅在客户使用场景中运用该权限。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （11）蓝牙，用于U-Key验证等用途，且仅在客户使用场景中运用该权限。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （12）网络通讯，用于与服务端进行通讯。拒绝授权后，手机银行所有功能无法使用。系统后台保存客户交易时所使用设备的网络信息，包括IP、端口等信息。
        </p>
        <p class="distance_50">
          上述功能可能需要您在您的设备中向我行开启您的相机（摄像头）、地理位置（位置信息）、麦克风等访问权限，以实现这些功能所涉及的信息的收集和使用。请您注意，您开启这些权限即代表您授权我行可以收集和使用这些信息来实现上述功能，如您取消了这些授权，则我行将不再继续收集和使用您的这些信息，也无法为您提供上述与这些授权所对应的功能。
        </p>
        <p class="distance_50">
          如在上述情形之外收集或使用您的信息，我行会事先征求您的同意，并向您充分告知信息收集和使用的目的、方式和范围。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）我行如何使用您的个人信息
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          1.在我行向您提供金融产品或服务，以及改进这些产品或服务时使用。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          2.在我行向您提供金融服务期间，您授权我行持续收集和使用您的相关个人信息。在您注销服务或取消授权时，我行将停止收集及使用您的相关个人信息，但我行会根据法律法规及监管的要求在业务资料归档、审计、监管协查等领域继续使用此前收集的您的相关个人信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          3.为提升您的体验，或为防范风险，我行会对您服务使用情况的相关信息进行统计分析、加工，但这些信息不会包含您的任何身份识别信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          4.因反洗钱和反恐怖融资需要，授权我行向且仅向涉及办理被调查业务的第三方金融机构提供您在我行的相关资料。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          5.将您的个人信息用于法律允许的其它用途。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          6.当我行要将您的用户信息，用于本政策载明的收集目的、用途或合理相关范围以外的其他用途时，我行将在使用前再次征得您的同意
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          7.根据相关法律法规、监管要求及国家标准，以下情形中，我行可能会收集、使用您的相关个人信息而无需另行征求您的授权同意：
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （1）与国家安全、国防安全直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （2）与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （3）与犯罪侦查、起诉、审判和判决执行等直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （5）所收集的个人信息是您自行向社会公众公开的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （7）根据您要求签订和履行合同所必需的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （9）出于公共利益开展统计或学术研究所必需，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （10）法律法规及监管要求规定的其他情形。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          二、我行如何使用Cookie和同类技术
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）Cookie
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          为确保网站正常运转，我行会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好或者您使用的商品或服务等数据。我行不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除
          Cookie。有关详情，请参见
          AboutCookies.org。您可以清除计算机上保存的所有
          Cookie，大部分网络浏览器都设有阻止 Cookie
          的功能。但如果您这么做，则需要在每一次访问我行的网站时亲自更改用户设置。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）网站信标和像素标签
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          除 Cookie
          外，我行还会在网站上使用网站信标和像素标签等其他同类技术。例如，我行向您发送的电子邮件可能含有链接至我行网站内容的点击
          URL。如果您点击该链接，我行则会跟踪此次点击，帮助我行了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我行能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时退订。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）Do Not Track（请勿追踪）
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do Not
          Track
          请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了
          Do Not Track，那么我行的所有网站都会尊重您的选择。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）日志与位置信息
        </p>
        <p class="distance_50">
          为提升您的体验及保护您的资金安全之目的，我行可能会自动收集日志信息和位置信息。我行不会将这些信息用于本政策撰述目的之外的任何用途。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          日志信息包括：
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          1.设备或软件信息，例如您的移动设备、网页浏览器或您用于接收我行服务的其他程序所提供的配置信息、IP地址、无线网络接入信息，以及您的移动设备所用的版本和设备识别码；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          2.您在设备上曾使用的移动应用（APP）和其他软件的信息。位置信息指您开启设备定位功能并使用我行基于位置提供的相关服务时，我行收集的有关您位置的信息。您可以通过关闭定位功能随时停止我行对您的地理位置信息的收集。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          三、我行如何共享、转让和公开披露您的个人信息
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）共享
        </p>
        <p class="distance_50">
          除以下情况外，我行不会主动与其他任何公司、组织和个人分享您的个人信息：
        </p>
        <p class="distance_50">
          1.政府、监管部门或司法机关要求共享等法律法规规定的情况下，我行将向其共享您的个人信息；
        </p>
        <p class="distance_50">
          2.事先获得您的明确同意。如因业务需要对外共享您的个人信息时，我们会向您告知共享个人信息的目的、范围和数据接收方身份，并征得您的授权或同意。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）转让
        </p>
        <p class="distance_50">
          我行不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        </p>
        <p class="distance_50">
          1．在获取明确同意的情况下转让：获得您的明确同意或授权后，我行会向其他方转让您的个人信息；
        </p>

        <p class="distance_50">
          2．根据法律法规规定或强制性的行政与司法要求；
        </p>
        <p class="distance_50">
          3．根据法律法规和商业惯例，在合并、收购、资产转让、兼并、重组或破产清算等类似交易中，如涉及到个人信息转让，我行会要求新的持有您个人信息的公司、组织继续受本徇私政策的约束，否则我行将要求该公司、组织重新向您征求授权同意。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）公开披露
        </p>
        <p class="distance_50">我行仅会在以下情况下，公开披露您的个人信息：</p>
        <p class="distance_50">1．获得您明确同意或授权后；</p>
        <p class="distance_50">
          2．政府、监管部门或司法机关要求披露等法律法规规定的情况下，我行将公开披露您的个人信息，且无需征得您的同意。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）征得授权同意的例外
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          根据相关法律法规及监管要求、国家标准，以下情形中，我行可能会共享、转让、公开披露用户信息无需事先征得您授权同意：
        </p>
         <p class="distance_50" style="color:#000;font-weight:bold">
          （1）与履行国家法律法规及行业主管部门有关规定的义务相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （2）与国家安全、国防安全直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （3）与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （4）与犯罪侦查、起诉、审批和判决执行等直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （5）出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （6）您自行向社会公众公开的个人信息；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （7）从合法公开披露的信息中收集的用户信息，如合法的新闻报道、政府信息公开等渠道。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （8）用于维护所提供的金融产品或服务的安全稳定运行所必需的，例如识别、处置金融产品或服务中的欺诈或被盗用等。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          四、我行如何存储和保护您的个人信息
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）存储
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          按照相关法律法规规定，我行将中华人民共和国境内（不包括香港、澳门特别行政区及台湾地区）提供服务过程中收集和产生的您的个人信息存储在中华人民共和国境内（不包括香港、澳门特别行政区及台湾地区）。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          我行仅在为您提供服务及相关服务之目的所必需的期限内和法律法规及监管规定的时限内留存您的个人信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          如果终止服务，我行将及时停止收集您个人信息，并对所持有的您的个人信息进行删除或匿名化处理，法律法规或监管机构对个人信息存储时间另有规定的除外。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）保护
        </p>
        <p class="distance_50">
          1.我行已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我行会采取一切合理可行的措施，保护您的个人信息。例如：我行会使用加密技术确保数据的保密性；我行会使用受信赖的保护机制防止数据遭到恶意攻击；我行会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我行会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        </p>
        <p class="distance_50">
          2.我们会采取一切合理可行的措施，确保不收集无关的个人信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          3.请您理解，由于技术水平局限以及可能存在的恶意攻击，有可能出现我行无法合理预见、防范、避免、控制的意外情况。互联网并非绝对安全的环境，请使用复杂密码，协助我行保证您的账号安全。
        </p>
        <p class="distance_50">
          4.如发生个人信息安全事件，我行将按照法律法规要求，及时将事件相关情况以邮件或信函或电话或推送通知等方式告知您，或采取合理、有效的方式发布公告。同时，我行还将依据监管规定，主动上报个人信息安全事件处置情况。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          五、您如何管理您的个人信息
        </p>
        <p class="distance_50">
          按照中国相关的法规和监管规定，我行保障您对自己的个人信息行使以下权利：
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）访问、更正及更新您的个人信息
        </p>
        <p class="distance_50">
          您有权通过我行网上银行、手机银行、微信银行、电话银行等渠道的个人信息修改功能服务访问及更正、更新您的个人信息，法律法规规定的例外情况除外。您有责任及时更新您的个人信息。在您修改个人信息之前，我行会验证您的身份。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）删除您的个人信息
        </p>
        <p class="distance_50">
          在以下情形中，您可以向我行提出删除个人信息的请求：
        </p>
        <p class="distance_50">1．如果我行处理您个人信息的行为违反法律法规；</p>
        <p class="distance_50">
          2．如果我行收集、使用您的个人信息，却未征得您的同意；
        </p>
        <p class="distance_50">
          3．如果我行处理个人信息的行为违反了与您的约定；请您注意，我行电子银行签约用户仅在手机设备中删除手机银行App时，我行不会解除您的电子银行签约，有关您手机银行的一切信息不会删除。
        </p>
        <p class="distance_50">
          4．如果您终止我行提供的账户服务和电子银行服务；
        </p>
        <p class="distance_50">5．如果我行不再为您提供服务。</p>
        <p class="distance_50">
          如我们决定响应您的删除请求，我们还将同时通知从我行获得您个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
        </p>
        <p class="distance_50">
          当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）注销用户
        </p>
        <p class="distance_50">
          如您为我行手机银行用户，您可通过营业网点、手机银行等渠道注销您的手机银行签约账户。您注销手机银行的行为是不可逆行为，一旦注销，我行将不再通过手机银行收集您的个人信息，并将删除有关您手机银行的信息，法律法规或监管机构对个人信息存储时间另有规定的除外。您可以自主选择卸载或停止使用浦发银行手机银行客户端，以阻止我行获取您的个人信息。请您注意，我行手机银行签约绑定客户仅在手机设备中删除手机银行客户端时，我行不会注销您的手机银行账户，有关您手机银行账户的一切信息不会删除。您仍需要注销您的手机银行签约账户方能达到以上目的。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）改变您的授权范围
        </p>
        <p class="distance_50">
          您有权决定是否继续对您个人信息采集、使用等进行授权，您可以通过浦发银行手机银行首页搜索“安全”，进入安全页面，关闭本隐私政策的授权，关闭后我行将不再继续采集、使用、您相应的个人信息，请您理解如您取消授权，我行将无法为您提供电子渠道服务（含浦发手机银行、网上银行）服务，也不再继续处理您相应的个人信息（如您已就具体产品或服务与我行另行签署授权的除外），但您取消本隐私政策授权的决定，不会影响我行此前基于您授权已开展的个人信息处理。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （五）获取您的个人信息副本
        </p>
        <p class="distance_50">
          您有权获取您的个人信息副本。如果您需要获取我行收集的您的个人信息副本，您可通过联系附近的浦发营业网点，在符合相关法律法规且技术可行的前提下，我行将根据您的要求向您提供您的个人信息副本。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （六）响应您的上述请求
        </p>
        <p class="distance_50">
          为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我行可能会先要求您验证自己的身份，然后再处理您的请求。请您理解，对于某些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我行可能会予以拒绝。
        </p>
        <p class="distance_50">
          在以下情形中，按照法律法规要求，我行将无法响应您的请求：
        </p>
        <p class="distance_50">1.与国家安全、国防安全直接相关的；</p>
        <p class="distance_50">
          2.与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="distance_50">
          3.与犯罪侦查、起诉、审判和判决执行等直接相关的；
        </p>
        <p class="distance_50">4.有充分证据表明您存在主观恶意或滥用权利的；</p>
        <p class="distance_50">
          5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
        </p>
        <p class="distance_50">6.涉及商业秘密的。</p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          六、我行如何处理未成年人的信息
        </p>

        <p class="distance_50" style="color:#000;font-weight:bold">
          我行的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          对于经父母同意而收集未成年个人信息的情况，我行只会在法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          七、本政策如何更新
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          根据国家法律法规变化及服务运营需要，我行可能会对本政策及相关规则进行修改，修改后的内容会通过我行网上银行、手机银行等渠道予以公告，并取代此前相关内容。在公告期内，您可以选择是否继续同意授权，若您不愿接受公告内容，应在公告内容正式实施前取消授权。如您继续使用我行服务，即表示您已充分阅读、理解并接受更新后的政策并愿意接受更新后的政策约束。未经您的明确同意，我行不会削减您按照本隐私政策所应享有的权利。您应不时关注相关公告、提示信息及协议、规则等相关内容的变动。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          八、如何联系我行
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          如您对本隐私政策有任何疑问、意见或建议，请联系我行客服热线：95528。受理您的问题后，我行会及时处理，将在15个工作日内给予答复。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          公司名称：上海浦东发展银行股份有限公司
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          注册地址：上海市中山东一路12号
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          邮箱地址： dcsc02@spdb.com.cn
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          请您在同意之前仔细阅读本隐私政策，确保对其内容含义及相应法律后果已全部知晓并充分理解。您选择“同意”即视为您接受并签署本隐私政策授权，我行将按照相关法律法规及本政策合法使用和保护您的个人信息。
        </p>


        <p class="distance_50">附件：</p>
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          浦发银行SDK使用场景列表
        </p>
        <p class="distance_50">
          当您使用浦发银行App的功能或服务时，在特定使用场景下，App会使用具有相应业务资质及服务能力的第三方服务商提供的应用软件开发工具包（简称“SDK”）来为您提供服务，此时需要通过SDK来收集您的必要信息。以下表格包含了您在使用APP的过程中可能触及到的SDK产品，供您查询了解。
        </p>
        <p class="distance_50">
          我们将尽全力保护您的个人信息和合法权益，再次感谢您的信任！
        </p>
        <table border="1" style="border-collapse: collapse;" class="table">
          <thead>
            <tr>
              <th>SDK名称</th>
              <th>采集数据</th>
              <th>提供服务/功能</th>
              <th>所属公司</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                个推SDK（包括小米推送SDK、华为推送SDK、OPPO推送SDK、VIVO推送SDK、魅族推送SDK）
              </td>
              <td>
                手机终端标识信息、手机厂商、手机型号、系统类型、系统版本、电话状态信息
              </td>
              <td>App消息推送功能，推送服务及账户变动通知</td>
              <td>浙江每日互动网络科技有限公司</td>
            </tr>
            <tr>
              <td>依图SDK</td>
              <td>手机终端标识信息，获取摄像头、麦克风权限</td>
              <td>人脸识别、活体检测</td>
              <td>上海依图网络科技有限公司</td>
            </tr>
            <tr>
              <td>飞天Ukey SDK</td>
              <td>手机电话状态信息，麦克风权限</td>
              <td>Ukey安全认证功能</td>
              <td>飞天诚信科技股份有限公司</td>
            </tr>
            <tr>
              <td>天地融Ukey SDK</td>
              <td>手机电话状态信息，麦克风权限</td>
              <td>Ukey安全认证功能</td>
              <td>天地融科技股份有限公司</td>
            </tr>
            <tr>
              <td>银联HCE SDK</td>
              <td>手机终端标识信息</td>
              <td>银联HCE、无卡支付功能</td>
              <td>中国银联</td>
            </tr>
            <tr>
              <td>腾讯设备指纹SDK</td>
              <td>手机终端标识信息、位置信息、电话状态信息</td>
              <td>网络贷款申请过程中的反欺诈识别功能</td>
              <td>腾讯公司</td>
            </tr>
            <tr>
              <td>大智慧SDK</td>
              <td>手机终端标识信息、电话状态信息、麦克风权限</td>
              <td>提供贵金属、商品、外汇行情服务</td>
              <td>大智慧</td>
            </tr>
            <tr>
              <td>中国金融认证中心（CFCA）SDK</td>
              <td>
                获取客户数据： 姓名、证件类型、证件号码、电话号码 设备类数据：
                手机终端标识信息、手机厂商、手机型号、系统类型、系统版本、网络类型、IP、MAC地址、电话状态；
              </td>
              <td>
                向CFCA申请专属于用户本人的数字证书，保障手机银行交易安全。
              </td>
              <td>中国金融认证中心（CFCA）</td>
            </tr>
            <tr>
              <td>科大讯飞语音SDK</td>
              <td>
                麦克风权限
              </td>
              <td>
                语音银行中的语音识别功能
              </td>
              <td>科大讯飞股份有限公司</td>
            </tr>
            <tr>
              <td>合合信息OCR SDK</td>
              <td>
                摄像头权限
              </td>
              <td>
                卡号、身份证件识别服务中的拍照、图像识别功能
              </td>
              <td>上海合合信息技术发展有限公司</td>
            </tr>
            <tr>
              <td>视+AR SDK</td>
              <td>
                摄像头权限
              </td>
              <td>
                AR识别
              </td>
              <td>视辰信息科技（上海）有限公司</td>
            </tr>
            <tr>
              <td>极验SDK</td>
              <td>
                手机终端标识信息、手机厂商、手机型号、设备名称、系统语言、系统类型、系统版本、网络类型、IP地址
              </td>
              <td>
                验证码校验
              </td>
              <td>武汉极意网络科技有限公司</td>
            </tr>
            <tr>
              <td>电子社保SDK</td>
              <td>
                获取客户数据：姓名、证件类型、证件号码、电话号码、实体社保卡号（二级）
                设备类数据：IOS:UUID、手机型号、系统版本；安卓：安卓ID、手机型号、系统版本
              </td>
              <td>
                访问全国社保卡平台
              </td>
              <td>金保信社保卡科技有限公司</td>
            </tr>
            <tr>
              <td>微通SDK</td>
              <td>
                无
              </td>
              <td>
                密码键盘
              </td>
              <td>北京微通新成公司</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 24px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
.table{
  margin: 20px 10px;
}
</style>
